<section class="benchmark-library" aria-labelledby="benchmark-library-title">
  <div class="benchmark-library__inner">
    <p class="benchmark-library__eyebrow">Benchmarking library</p>

    <h2 id="benchmark-library-title" class="benchmark-library__title">
      Explore trusted clinical datasets
    </h2>

    <p class="benchmark-library__text">
      Start with a benchmark built around meaningful healthcare outcomes.
    </p>
  </div>

  <ul class="benchmark-library__cards" *ngIf="isLoading" aria-busy="true" aria-label="Loading datasets">
    <li class="benchmark-library__card benchmark-library__card--skeleton" *ngFor="let _ of [1, 2, 3]"></li>
  </ul>

  <ul class="benchmark-library__cards" *ngIf="!isLoading && datasets.length">
    <li class="benchmark-library__card" *ngFor="let dataset of datasets">
      <span class="benchmark-library__card-icon" aria-hidden="true">
        <img
          *ngIf="dataset.icon === 'oral'"
          class="benchmark-library__card-icon-img benchmark-library__card-icon-img--oral"
          src="/assets/images/landing/icon-oral-cancer.png"
          alt=""
          width="22"
          height="31"
        />
        <img
          *ngIf="dataset.icon === 'breast'"
          class="benchmark-library__card-icon-img benchmark-library__card-icon-img--breast"
          src="/assets/images/landing/icon-breast-cancer.png"
          alt=""
          width="15"
          height="30"
        />
        <img
          *ngIf="dataset.icon === 'default'"
          class="benchmark-library__card-icon-img benchmark-library__card-icon-img--default"
          src="/assets/images/landing/icon-default-dataset.png"
          alt=""
          width="22"
          height="28"
        />
      </span>

      <h3 class="benchmark-library__card-title">{{ dataset.title }}</h3>
      <p class="benchmark-library__card-text" *ngIf="dataset.description">{{ dataset.description }}</p>

      <div class="benchmark-library__card-footer">
        <div class="benchmark-library__metric" *ngIf="dataset.primaryMetric">
          <p class="benchmark-library__metric-label">Primary metric</p>
          <p class="benchmark-library__metric-value">{{ dataset.primaryMetric }}</p>
        </div>

        <a
          class="benchmark-library__btn"
          [routerLink]="['/reference/dataset', dataset.id]"
        >
          View dataset
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M8.79 2.29a1 1 0 0 1 1.42 0l4.5 4.5a1 1 0 0 1 0 1.42l-4.5 4.5a1 1 0 0 1-1.42-1.42L11.09 9H2a1 1 0 0 1 0-2h9.09L8.79 3.71a1 1 0 0 1 0-1.42Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
    </li>
  </ul>

  <a class="benchmark-library__view-all" routerLink="/reference">
    View all datasets
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M8.79 2.29a1 1 0 0 1 1.42 0l4.5 4.5a1 1 0 0 1 0 1.42l-4.5 4.5a1 1 0 0 1-1.42-1.42L11.09 9H2a1 1 0 0 1 0-2h9.09L8.79 3.71a1 1 0 0 1 0-1.42Z"
        fill="currentColor"
      />
    </svg>
  </a>
</section>
